import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select
} from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const TicketsUserSelect = ({ selectedUserIds = [], onChange }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const { data } = await api.get("/users", {
          params: { pageNumber: 1, searchParam: "" }
        });
        setUsers(data.users);
      } catch (err) {
        toastError(err);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div style={{ width: 150, marginTop: -4, marginLeft: 6 }}>
      <FormControl fullWidth margin="dense">
        <Select
          multiple
          displayEmpty
          variant="outlined"
          value={selectedUserIds}
          onChange={event => onChange(event.target.value)}
          renderValue={() => i18n.t("ticketsUserSelect.placeholder")}
          MenuProps={{
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
            getContentAnchorEl: null
          }}
        >
          <MenuItem dense value={0}>
            <Checkbox
              size="small"
              color="primary"
              checked={selectedUserIds.indexOf(0) > -1}
            />
            <ListItemText primary={i18n.t("ticketsUserSelect.unassigned")} />
          </MenuItem>
          {users.map(item => (
            <MenuItem dense key={item.id} value={item.id}>
              <Checkbox
                size="small"
                color="primary"
                checked={selectedUserIds.indexOf(item.id) > -1}
              />
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsUserSelect;
